import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { NFT_OUTLINE_OFFSET } from '@app/pages/Prototype/Grid/GridItem/NFT/styles';
import { ContentType } from '@app/store/types/yat-page-actions';

import { GRID_GUTTER_DESKTOP, GRID_GUTTER_LAPTOP, GRID_GUTTER_MOBILE } from '../../config';

const ICON_HIT_AREA = 8;

interface OuterProps {
    $width: string;
    $dragging?: boolean;
}

export const GridItemOuter = styled(motion.div).attrs<OuterProps>(({ $width, $dragging }) => ({
    style: { width: $width, zIndex: $dragging ? 1 : 0 },
}))<OuterProps>`
    ${({ $dragging }) =>
        !$dragging &&
        css`
            transition-property: top, left;
            transition-duration: ${({ theme }) => theme.transitions.speeds.normal}s;
            transition-timing-function: ${({ theme }) => theme.transitions.easesCss.on};
            will-change: top, left;
        `}
`;

interface InnerProps {
    $draggable?: boolean;
}

export const GridItemInner = styled.div<InnerProps>`
    position: relative;

    ${({ $draggable }) =>
        $draggable &&
        css`
            cursor: grab;
        `}
`;

export const DraggableMasonryWrapper = styled.div`
    > ${GridItemOuter} {
        margin-bottom: ${GRID_GUTTER_MOBILE}px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.tabletSmall}) {
        padding-top: 60px;

        > ${GridItemOuter} {
            margin-bottom: ${GRID_GUTTER_LAPTOP + 15}px;

            &:nth-child(1),
            &:nth-child(3) {
                > * {
                    margin-top: ${GRID_GUTTER_LAPTOP + 15}px;
                }
            }
        }
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        > ${GridItemOuter} {
            margin-bottom: ${GRID_GUTTER_DESKTOP}px;

            &:nth-child(1),
            &:nth-child(3) {
                > * {
                    margin-top: ${GRID_GUTTER_DESKTOP}px;
                }
            }
        }
    }
`;

interface DraggableIconProps {
    $type: ContentType;
}

export const DraggableIconWrapper = styled.div<DraggableIconProps>`
    position: absolute;
    top: ${({ $type }) => ($type === ContentType.NFT ? NFT_OUTLINE_OFFSET : 0) - ICON_HIT_AREA}px;
    right: ${({ $type }) => ($type === ContentType.NFT ? NFT_OUTLINE_OFFSET : 0) - ICON_HIT_AREA}px;
    padding: ${ICON_HIT_AREA * 2}px;
    z-index: 99;
`;
